import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'AppDownload',
  emits: ["close"],
  setup(__props, { emit }: { emit: ({
    (e: 'close'): void
}), expose: any, slots: any, attrs: any }) {



function onClose() {
    emit('close')
}

return { __sfc: true,emit, onClose }
}

})